package br.com.texeratx.boardgametimeapp.ui.screens.games.model

data class CatalogGameUI(
    val id: Long,
    val name: String,
    val imageUrl: String?,
    val minPlayers: Int?,
    val maxPlayers: Int?,
    val duration: Int?,
    val bggUrl: String?,
    val categoryId: Long?,
    val categoryName: String?,
    val yearPublished: Int?,
    val bggRank: Int?,
    val ratingAverage: Double?,
    val complexityAverage: Double?
)
